import { LitElement, html } from 'vendor/lit'
import { debounce } from 'utils/general'
class HHFiltersWrapper extends LitElement {
  constructor() {
    super()
    this._self = this
    this.pageType = this.getAttribute('page-type') || 'collection'
    this.filterData = []
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.closeDetails = this.closeDetails.bind(this)
    this.onHistoryChange = this.onHistoryChange.bind(this)
    this.closeMobileFilters = this.closeMobileFilters.bind(this)
    this.resetForm = this.querySelector('.js-reset-form')
    this.filtersWrapper = this.querySelector('.js-active-filters')
    this.filterOptions = this.querySelectorAll('input')
    this.filters = Array.from(this.querySelectorAll('input'))
      .filter((input) => input.checked)
      .map((input) => {
        if (!input.checked) return
        const { name, value, id } = input
        return { name: name, value: value, id: id }
      })

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.classList.contains('js-sort-by-clone')) {
        document
          .querySelector(`#main-${this.pageType}-filters .js-sort-input`)
          .setAttribute('data-sorted', true)
      }

      if (event.target.hasAttribute('value')) {
        this.dispatchFilterApplyEvent(event.target)
      }

      this.initColorSwatches()
      this.toggleCustomFilters()
      this.toggleFilters()
      this.toggleResetButton()
      this.onSubmitHandler(event)
    }, 500).bind(this)

    this.initColorSwatches()
    this.toggleResetButton()
    this.toggleFilters()
    this.onCheckboxKeydown = this.onCheckboxKeydown.bind(this)
    this.syncCheckboxAria = this.syncCheckboxAria.bind(this)
  }

  connectedCallback() {
    const submitInputs = this.querySelectorAll('.js-filter-submit')
    const sortInput = document.querySelector(
      `#main-${this.pageType}-filters .js-sort-input`
    )
    const sortInputClone = this.querySelector('.js-sort-by-clone')
    const closeButton = this.querySelector('.js-close')
    const activeFilter = this.querySelector('.js-active-filters')

    this.bindActiveFacetButtonEvents()
    window.addEventListener('popstate', this.onHistoryChange)
    // document.body.addEventListener('click', this.closeDetails)
    submitInputs.forEach((element) => {
      element.addEventListener('click', this.debouncedOnSubmit)
    })
    this.filterOptions.forEach((input) => {
      if (input.closest('.list-colors')) {
        input.addEventListener('change', (e) => this.colorSwatchAction(e))
      }

      input.addEventListener('change', this.debouncedOnSubmit)
      input.addEventListener('change', () => this.syncCheckboxAria(input))
    })

    this.bindCheckboxLabels()
    activeFilter?.addEventListener('click', (e) => this.removeFilter(e))
    sortInput &&
      this.querySelector('.js-sort-by-clone').addEventListener(
        'change',
        this.debouncedOnSubmit
      )
    sortInput &&
      sortInput.addEventListener('change', (e) => {
        const { value } = e.detail
        sortInputClone.value = value

        sortInputClone.dispatchEvent(
          new CustomEvent('change', {
            bubbles: true,
            composed: true,
            detail: {
              value,
            },
          })
        )
      })
    closeButton?.addEventListener('click', this.closeMobileFilters)
    this.toggleCustomFilters()
    this.resetForm
      .querySelector('a')
      .addEventListener('click', this.resetFilters.bind(this))
  }

  resetFilters(e) {
    e.preventDefault()

    document.querySelectorAll('hh-filters-wrapper input').forEach((input) => {
      input.checked = false

      const label = this.getCheckboxLabel(input)
      if (label?.hasAttribute('data-checked')) {
        label.setAttribute('data-checked', false)
      }

      this.syncCheckboxAria(input)
    })

    this.debouncedOnSubmit(e)
  }

  dispatchFilterApplyEvent(target) {
    // Ignore unchecked checkboxes
    if (target.localName == 'input' && target.type == 'checkbox' && !target.checked) return

    const filterLabel = target.getAttribute('data-filter-label')
    const filterSelection = target.value
    document.dispatchEvent(
      new CustomEvent('filter:apply', {
        detail: {
          filterLabel,
          filterSelection,
        },
      })
    )
  }

  toggleCustomFilters() {
    const customFilters = Array.from(
      this.querySelectorAll('form .js-filter[is-custom-filter]')
    )

    let clearedChildFilter
    do {
      clearedChildFilter = false

      customFilters.forEach((customFilter) => {
        const customFilterName = customFilter.getAttribute('is-custom-filter')
        const customFilterActive = Array.from(
          this.querySelectorAll('.js-filter input[has-custom-filter]')
        ).some((input) => {
          const customFilterTargets = input
            .getAttribute('has-custom-filter')
            .split(',')
            .map((target) => target.trim())

          return input.checked && customFilterTargets.includes(customFilterName)
        })

        if (customFilterActive) return

        customFilter.querySelectorAll('input:checked').forEach((input) => {
          input.checked = false
          this.getCheckboxLabel(input)?.removeAttribute('data-checked')
          this.syncCheckboxAria(input)
          clearedChildFilter = true
        })
      })
    } while (clearedChildFilter)

    customFilters.forEach((customFilter) => {
      const customFilterName = customFilter.getAttribute('is-custom-filter')
      const customFilterActive = Array.from(
        this.querySelectorAll('.js-filter input[has-custom-filter]')
      ).some((input) => {
        const customFilterTargets = input
          .getAttribute('has-custom-filter')
          .split(',')
          .map((target) => target.trim())

        return input.checked && customFilterTargets.includes(customFilterName)
      })

      customFilter.classList.toggle('show-filter', customFilterActive)
      customFilter.querySelectorAll('input').forEach((input) => {
        input.toggleAttribute('disabled', !customFilterActive)
        this.syncCheckboxAria(input)
      })
    })
  }

  getActiveFilters() {
    return Array.from(this.querySelectorAll('input'))
      .filter((input) => input.checked)
      .map((input) => {
        if (!input.checked) return
        const { name, value, id } = input
        return {
          name: name,
          value: value,
          id: id,
          label: input.getAttribute('data-filter-value-label') || value,
        }
      })
  }

  removeFilter(e) {
    const target = e.target

    if (
      target.getAttribute('data-action') !== 'remove' &&
      !target.closest('.active-filter')
    )
      return

    const activeFilter = target.closest('.active-filter')
    const name = target.getAttribute('data-name') || activeFilter?.getAttribute('data-name')
    const value = target.getAttribute('data-value') || activeFilter?.getAttribute('data-value')
    const id = target.getAttribute('data-id') || activeFilter?.getAttribute('data-id')

    this.querySelector(
      `input${value ? `[value="${this.escapeAttributeSelectorValue(value)}"]` : ''}${
        name ? `[name="${this.escapeAttributeSelectorValue(name)}"]` : ''
      }${id ? `[id="${this.escapeAttributeSelectorValue(id)}"]` : ''}`
    )?.click()
  }

  getCheckboxLabel(input) {
    if (!input) return null
    return (
      input.closest('.filter__item')?.querySelector('.filter__checkbox') ||
      input.closest('label') ||
      null
    )
  }

  escapeAttributeSelectorValue(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')
  }

  escapeHTML(value) {
    const div = document.createElement('div')
    div.textContent = value
    return div.innerHTML
  }

  onCheckboxKeydown(event) {
    const { key } = event
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return
    event.preventDefault()

    const label = event.currentTarget
    const input = label.closest('.filter__item')?.querySelector('input') || label.querySelector('input')

    if (input && !input.disabled) {
      input.click()
      this.syncCheckboxAria(input)
    }
  }

  syncCheckboxAria(input) {
    const label = this.getCheckboxLabel(input)
    if (!label) return
    label.setAttribute('role', 'checkbox')
    label.setAttribute('aria-checked', input.checked ? 'true' : 'false')
    label.setAttribute('aria-disabled', input.disabled ? 'true' : 'false')
  }

  bindCheckboxLabels(root = this) {
    if (!root?.querySelectorAll) return
    root.querySelectorAll('.filter__checkbox').forEach((label) => {
      label.setAttribute('tabindex', '0')
      label.removeEventListener('keydown', this.onCheckboxKeydown)
      label.addEventListener('keydown', this.onCheckboxKeydown)

      const input = label.closest('.filter__item')?.querySelector('input') || label.querySelector('input')
      if (input) this.syncCheckboxAria(input)
    })
  }

  toggleFilters() {
    const activeFilters = this.getActiveFilters()
    if (!this.filtersWrapper) return

    const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
    </path></svg>`

    let injectFilterHtml = ''
    activeFilters.forEach((filter) => {
      const label = this.escapeHTML(filter?.label || filter?.value || 'Filter')
      const value = this.escapeHTML(filter?.value || '')
      const name = this.escapeHTML(filter?.name || '')
      const id = this.escapeHTML(filter?.id || '')
      injectFilterHtml += `<li
        class="active-filter"
        data-id="${id}"
        data-name="${name}"
        data-value="${value}"
        data-action="remove">
        <span>${
          filter.name === 'filter.v.availability'
            ? `${filter.value === '1' ? 'in stock' : 'not in stock'}`
            : label
        }</span>
        <button
          type="button"
          class="active-filter__remove"
          data-action="remove"
          data-id="${id}"
          data-name="${name}"
          data-value="${value}"
          aria-label="Remove filter ${label}">
          ${closeIcon}
        </button>
      </li>`
    })

    this.filtersWrapper.innerHTML = injectFilterHtml
  }

  toggleResetButton() {
    const hasActiveFilter = Array.from(this.querySelectorAll('input')).some(
      (input) => input.checked
    )
    hasActiveFilter
      ? this.resetForm?.classList.remove('hidden')
      : this.resetForm?.classList.add('hidden')
    hasActiveFilter
      ? this?.classList.add('has-active-filter')
      : this?.classList.remove('has-active-filter')
  }

  async initColorSwatches() {
    const colorSwatches = this.querySelectorAll(
      '.list-colors [data-color-swatch]'
    )

    colorSwatches.forEach((swatch) => {
      let colorName = swatch.getAttribute('data-color-swatch')

      if (colorName.includes('é')) {
        colorName = colorName.replace('é', 'e')
      }

      let label = swatch.closest('label')

      /*
      if (!label.getAttribute('data-tooltip')) {
        label?.addEventListener('mouseenter', (e) =>
          this.toggleTooltip(e, colorName)
        )
        label?.addEventListener('mouseleave', (e) => this.toggleTooltip(e))

        label.setAttribute('data-tooltip', true)
      }
      */
    })
  }

  colorSwatchAction(e) {
    const { target } = e
    const isChecked = target.checked

    this.getCheckboxLabel(target)?.setAttribute('data-checked', isChecked)
    target.setAttribute('aria-checked', isChecked)
    this.syncCheckboxAria(target)
  }

  toggleTooltip(e, colorName) {
    const tooltip = this.querySelector('.filter__list__color-tooltip')

    if (e.type === 'mouseenter') {
      tooltip.classList.add('show')
      tooltip.style.setProperty(
        '--tooltip-left',
        `${e.target.offsetLeft - 6}px`
      )
      tooltip.style.setProperty(
        '--tooltip-top',
        `${e.target.offsetTop + (e.target.clientHeight + 2)}px`
      )
      tooltip.style.setProperty(
        '--tooltip-adjust',
        `${e.target.clientWidth / 2 + 6}px`
      )
      tooltip.querySelector('.color-tooltip--name span').textContent = colorName

      const tooltipClient = this.querySelector(
        '.filter__list__color-tooltip'
      ).getBoundingClientRect()

      if (tooltipClient.x <= 7) {
        tooltip.classList.add('tooltip-exceed')
      } else {
        tooltip.classList.remove('tooltip-exceed')
      }
    } else {
      tooltip.classList.remove('tooltip-exceed')
      tooltip.classList.remove('show')
    }
  }

  closeMobileFilters() {
    this.dispatchEvent(
      new CustomEvent('closeModal', {
        bubbles: true,
      })
    )
  }

  closeDetails(event) {
    const detailsElements = this.querySelectorAll('.js-filter')
    detailsElements.forEach((detailsElement) => {
      if (!detailsElement.contains(event.target)) {
        detailsElement.open = false
      }
    })
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = Array.from(
      new FormData(
        event.target.name === 'sort_by'
          ? this.querySelector('form')
          : event.target.closest('form')
      )
    ).filter(function ([k, v]) {
      return v
    })

    let searchParams = ''
    if (this.pageType !== 'collection') {
      const currentSearchParams = new URLSearchParams(window.location.search)
      const query = `q=${currentSearchParams.get('q')}`
      searchParams = `${query}${
        new URLSearchParams(formData).toString() &&
        `&${new URLSearchParams(formData).toString()}`
      }`
    } else {
      searchParams = new URLSearchParams(formData).toString()
    }

    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    this.toggleActiveFacets()

    const requestedSearchParams = new URL(event.currentTarget.href).searchParams
    this.querySelectorAll('input[type="checkbox"][name]').forEach((input) => {
      input.checked = requestedSearchParams
        .getAll(input.name)
        .includes(input.value)
    })

    this.toggleCustomFilters()

    const customFilterInputs = Array.from(
      this.querySelectorAll(
        'form .js-filter[is-custom-filter] input[name]'
      )
    )
    const customFilterNames = new Set(
      customFilterInputs.map((input) => input.name)
    )

    customFilterNames.forEach((name) => {
      requestedSearchParams.delete(name)
      customFilterInputs
        .filter(
          (input) => input.name === name && input.checked && !input.disabled
        )
        .forEach((input) => requestedSearchParams.append(name, input.value))
    })

    this.renderPage(requestedSearchParams.toString(), event)
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById(`${this.capitalizeFirstLetter(this.pageType)}ProductGrid`)
      ?.setAttribute('aria-busy', 'true')

    document
      .getElementById(`main-${this.pageType}-filters`)
      .querySelector('.filters__loader')
      .classList.add('is-loading')

    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
      .catch((error) => {
        console.error('Filters | Unable to update results', error)
        document
          .getElementById(`${this.capitalizeFirstLetter(this.pageType)}ProductGrid`)
          ?.setAttribute('aria-busy', 'false')
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  renderProductGrid(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const innerHTML = parsedHTML.getElementById(
      `${this.capitalizeFirstLetter(this.pageType)}ProductGrid`
    ).innerHTML

    const counter = parsedHTML.querySelector('.count-label').textContent

    const parent = document.getElementById(
      `${this.capitalizeFirstLetter(this.pageType)}ProductGrid`
    )

    parent.innerHTML = innerHTML
    this.resolveRegionDependentProductGrid(parent)
    parent.setAttribute('aria-busy', 'false')

    const sourceStatus = parsedHTML.querySelector('[data-product-grid-status]')
    const targetStatus = document.querySelector('[data-product-grid-status]')
    if (sourceStatus && targetStatus) {
      Object.entries(sourceStatus.dataset).forEach(([key, value]) => {
        targetStatus.dataset[key] = value
      })
      targetStatus.textContent = ''
      setTimeout(() => {
        targetStatus.textContent = sourceStatus.dataset.resultMessage || ''
      }, 50)
    }

    const counterFooter = parsedHTML.querySelector('.count-label-footer')?.textContent
    const counterActiveFilters = parsedHTML.querySelector('.active-filters')?.textContent

    this.querySelector(
      '.js-product-available-count .count-label'
    ).textContent = `${counter}`

    if (counterFooter) {
      this.querySelector('.count-label-footer').textContent = `${counterFooter}`
    }

    if (counterActiveFilters !== undefined) {
      this.querySelector('.js-product-available-count .active-filters').textContent = `${counterActiveFilters}`
    }
  }

  resolveRegionDependentProductGrid(parent = document) {
    const productGrid = parent.querySelector?.('#main-collection-product-grid')

    if (!productGrid?.hasAttribute('data-region-dependent')) return

    if (typeof window.productGridCountryData === 'function') {
      if (window.countryData) {
        window.productGridCountryData(window.countryData, null)
      } else {
        document.addEventListener(
          'intl:data',
          (e) =>
            window.productGridCountryData(
              e.detail.countryData,
              e.detail.error
            ),
          { once: true }
        )

        setTimeout(() => {
          productGrid.removeAttribute('data-region-dependent')
        }, 1000)
      }
      return
    }

    productGrid.removeAttribute('data-region-dependent')
  }

  renderFilters(...args) {
    this.renderSingleFormFilters(
      `#${this.capitalizeFirstLetter(this.pageType)}FiltersForm`,
      ...args
    )
    this.renderSingleFormFilters(
      `#${this.capitalizeFirstLetter(this.pageType)}FiltersFormMobile`,
      ...args
    )
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      `${form} .js-filter`
    )
    const targetFacet = event?.target.closest('.js-filter')
    const focusedFilterId = targetFacet?.contains(document.activeElement)
      ? document.activeElement.getAttribute('for') || document.activeElement.id
      : null

    Array.from(facetDetailsElements).forEach((element) => {
      const parentElement = document.querySelector(
        `${form} .js-filter[data-index="${element.dataset.index}"]`
      )

      parentElement.innerHTML = element.innerHTML
      parentElement.querySelectorAll('input').forEach((input) => {
        if (input.closest('.list-colors')) {
          this.initColorSwatches()
          input.addEventListener('change', (e) => this.colorSwatchAction(e))
        }
        if (input.checked) {
          this.getCheckboxLabel(input)?.setAttribute('data-checked', true)
        } else {
          this.getCheckboxLabel(input)?.removeAttribute('data-checked')
        }
        input.addEventListener('change', () => this.syncCheckboxAria(input))
        input.addEventListener('click', this.debouncedOnSubmit)
      })
    })

    this.bindCheckboxLabels(document.querySelector(form))

    this.renderActiveFacets(parsedHTML)
    this.toggleFilters()
    this.toggleCustomFilters()

    if (focusedFilterId) {
      const focusedFilter = Array.from(
        document.querySelectorAll(`${form} .js-filter input`)
      ).find((input) => input.id === focusedFilterId)

      this.getCheckboxLabel(focusedFilter)?.focus()
    }

    setTimeout(() => {
      document
        .getElementById(`main-${this.pageType}-filters`)
        .querySelector('.filters__loader')
        .classList.remove('is-loading')
    }, 500)
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, {
        once: true,
      })
    })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: `main-${this.pageType}-filters`,
        section: document.getElementById(`main-${this.pageType}-filters`)
          .dataset.id,
      },
      {
        id: `main-${this.pageType}-product-grid`,
        section: document.getElementById(`main-${this.pageType}-product-grid`)
          .dataset.id,
      },
    ]
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-filters-wrapper', HHFiltersWrapper)
